import Vue from 'vue'
import axios, { Method, ResponseType } from 'axios'
import router from '@/router'
import RequestDefault from '@/utils/requestDefault'
import { BaseStore } from '@/store/modules/Base'
import { UserStore } from '@/store/modules/User'
// 发布者
import Subject from './Subject'
// 订阅者
import Observer from './Observer'
import { token } from '@/api/login'

const subject = new Subject()

let __API_LOGIN_ = false

// interface resTypes {
//   success: boolean,
//   state: string,
//   msg: string,
//   data?: any
// }

const codeMessage = {
  401: '需要重新登录~~身份信息失效了',
  403: '诶呀~~您无此权操作~~',
  404: '怎么办~~找不到服务器了~~',
  406: '不好啦~~您的账户在其他设备登录啦~~',
  500: '诶~~服务器闹小脾气了~~'
}

const service = axios.create({
  baseURL: RequestDefault.baseURL,
  headers: {
    'Content-type': 'application/json; charset=UTF-8'
  }
})

service.interceptors.request.use(
  config => {
    if (BaseStore.tokenData.token) {
      config.headers.Authorization = 'Bearer ' + BaseStore.tokenData.token
    }
    if (config.url === '/api/auth/token') {
      config.baseURL = RequestDefault.authToken
      config.headers.Authorization = 'Bearer ' + BaseStore.tokenData.refreshToken
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response): any => {
    return response.data
  },
  error => {
    const status = error.response && error.response.status
    console.log(error)
    console.log(status)
    switch (status) {
      case 401:
        // debugger
        Vue.prototype.$notify.warning({
          title: '401 身份信息失效',
          message: codeMessage[status]
        })
        BaseStore.REMOVE_TOKEN()
        UserStore.REMOVE_USER_INFO()
        router.replace({
          path: `/login?fullPath=${encodeURIComponent(location.hash.replace(/^#/, ''))}`
        })
        break
      case 403:
        Vue.prototype.$notify.warning({
          title: '403 权限异常',
          message: codeMessage[status]
        })
        break
      case 404:
        Vue.prototype.$notify.error({
          title: '404 接口异常',
          message: codeMessage[status]
        })
        break
      case 405:
        Vue.prototype.$notify.error({
          title: '405 错误的请求类型',
          message: codeMessage[status]
        })
        break
      case 406:
        // 您的账户在其他设备登录！
        Vue.prototype.$notify.error({
          title: '406 登录警告',
          message: codeMessage[status]
        })
        BaseStore.REMOVE_TOKEN()
        UserStore.REMOVE_USER_INFO()
        router.replace({
          path: `/login?fullPath=${encodeURIComponent(location.hash.replace(/^#/, ''))}`
        })
        break
      case 500:
        Vue.prototype.$notify.error({
          title: '500 服务器异常',
          message: codeMessage[status]
        })
        break
      case 504:
        // Toast({
        //   type: 'fail',
        //   message: codeMessage[status],
        //   forbidClick: true
        // })
        break
      default:
        Vue.prototype.$notify.error({
          title: 'CORS error',
          message: '服务器闹小脾气了~~'
        })
        break
    }
    return Promise.reject(error.response)
  }
)

/**
 * 基础请求
 * @param {string} url 请求路径
 * @param {object} option
 * @param {'GET'|'POST'|'PUT'|'DELETE'} option.method 请求方法
 * @param {any} option.data body传参数据
 * @param {any} option.params `GET`请求传参数据，这里直接用`formatParam()`去处理了
 */

interface optionType {
  method?: Method,
  data?: any,
  params?: any,
  responseType?: ResponseType,
  timeout?: number
}

function request (url: string, option?: optionType): Promise<any> {
  const api = {
    get: service.get,
    post: service.post,
    put: service.put,
    delete: service.delete,
    patch: service.patch
  }
  if (typeof option !== 'undefined' && option.method && option.method.toLowerCase() !== 'get') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return api[option.method.toLowerCase()](url, option.data)
  }
  return api.get(url, {
    responseType: option?.responseType,
    timeout: (option && option.timeout) || 30000
  })
}

// 代理拦截器，有token才正常放行，不然先调用静默登录再放行
export default new Proxy(request, {
  get (target, key: string, receiver) {
    if (['request', 'get', 'delete', 'head', 'post', 'put', 'patch'].includes(key)) {
      return new Proxy(Reflect.get(target, key, receiver), {
        apply: this.apply
      })
    } else {
      return Reflect.get(target, key, receiver)
    }
  },
  apply (target, thisArg, args) {
    return new Promise((resolve, reject) => {
      const time = Number(BaseStore.tokenTime) - new Date().getTime()
      // token过期小于10分钟
      // debugger
      const path = location.hash
      if (
        path !== '#/login' &&
        time <= 600000 &&
        args[0] !== '/login/gtpw/login' &&
        args[0] !== '/api/auth/token'
      ) {
        // 实例化订阅者
        const obs = new Observer(() => {
          target(args[0], args[1])
            .then(res => {
              // 移除订阅者
              subject.remove(obs)
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        })
        // 添加订阅者
        subject.add(obs)
        if (!__API_LOGIN_) {
          __API_LOGIN_ = true
          token()
            .then((res: any) => {
              console.log(res)
              if (res) {
                // 设置token
                BaseStore.SET_TOKEN(res)
                // 设置token过期时间
                const s = new Date().getTime() + (res.expiresIn * 1000)
                BaseStore.SET_TOKEN_EXPIRES_IN(s)
                // 发布者 通知 订阅者
                subject.notify()
                __API_LOGIN_ = false
              }
            })
        }
      } else {
        target(args[0], args[1])
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      }
    })
  }
})
